import {Injectable} from '@angular/core';
import {HttpService} from './http-service';
import {Observable} from 'rxjs/Rx';
import {
    TAction,
    TBlendedTipo,
    TMethodoTipo,
    TProdutoTipo,
    TProdutoView,
    TCertifyFlag,
    TClusterTipo,
    TProfileSexo,
    TZiptipo, THotspotList, THotspotFlag, TConsumoFlag,
} from "../app/enum";
import {Util} from "../app/util";
import {CONFIG} from "../app/config";

@Injectable()
export class WebstorService {

    constructor(public http: HttpService, public util: Util) { //public injector: Injector

    }

    webstor(action: TAction, profileID: number, hotspotID: number = 0, codeday: string = '', codeadd: boolean = false, codenew : boolean = false, pesquisa: string = '', json: any = null): Observable<any> {

        let url = 'SYNC-Webstor?Action=' + TAction[action] + '&ProfileID=' + profileID + '&HotspotID=' + hotspotID + '&Codeday=' + codeday + '&Codeadd=' + codeadd + '&Codenew=' + codenew + '&Pesquisa=' + pesquisa;

        if (json) {
            let dataJSon = 'JSon=' + JSON.stringify(json);
            return this.http.post(url, dataJSon);
        }

        return this.http.get(url);

    }

    assunto(action: TAction, json: any = null): Observable<any> {

        let url = 'SYNC-Assunto?Action=' + TAction[action];

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    negocio(action: TAction, brendedID: number = 0, partnerID: number = 0, profileID: number = 0, hotspotList : THotspotList = THotspotList.hlNegocio, hotspotFlag : THotspotFlag = THotspotFlag.hfHotspotNenhum, json: any = null): Observable<any> {

        let url = 'SYNC-Negocio?Action=' + TAction[action] + '&BrendedID=' + brendedID + '&PartnerID=' + partnerID + '&ProfileID=' + profileID + '&HotspotList=' + hotspotList + '&HotspotFlag=' + hotspotFlag;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    cluster(action: TAction, hotspotID: number = 0, produtoGtin: string = '', clusterTipo: TClusterTipo = TClusterTipo.clNone, produtoView: TProdutoView = TProdutoView.pdDetalhe, json: any = null): Observable<any> {

        let url = 'SYNC-Cluster?Action=' + TAction[action] + '&HotspotID=' + hotspotID + '&ProdutoGtin=' + produtoGtin + '&ClusterTipo=' + clusterTipo + '&ProdutoView=' + produtoView;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    precify(action: TAction, precifyID: number = 0, produtoID: number = 0, hotspotID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Precify?Action=' + TAction[action] + '&PrecifyID=' + precifyID + '&ProdutoID=' + produtoID + '&HotspotID=' + hotspotID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    departa(action: TAction, json: any = null): Observable<any> {

        let url = 'SYNC-Departa?Action=' + TAction[action];

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    deposit(action: TAction, depositID: number = 0, hotspotID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Deposit?Action=' + TAction[action] + '&DepositID=' + depositID + '&HotspotID=' + hotspotID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    ambient(action: TAction, ambientID: number = 0, hotspotID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Ambient?Action=' + TAction[action] + '&AmbientID=' + ambientID + '&HotspotID=' + hotspotID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    praceta(action: TAction, pracetaID: number = 0, hotspotID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Praceta?Action=' + TAction[action] + '&PracetaID=' + pracetaID + '&HotspotID=' + hotspotID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    projeto(action: TAction, json: any = null, params: string = ''): Observable<any> {

        let url = 'SYNC-Projeto?Action=' + TAction[action] + params;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    justify(action: TAction, json: any = null, consumoFlag: TConsumoFlag = TConsumoFlag.cfTudo): Observable<any> {

        let url = 'SYNC-Justify?Action=' + TAction[action] + '&ConsumoFlag=' + consumoFlag;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    hashtag(action: TAction, json: any = null): Observable<any> {

        let url = 'SYNC-Hashtag?Action=' + TAction[action];

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    branded(action: TAction, brandedID: number = 0, hotspotID: number = 0, profileID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Branded?Action=' + TAction[action] + '&BrandedID=' + brandedID + '&HotspotID=' + hotspotID + '&ProfileID=' + profileID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        let timeout = CONFIG.request.totalTimeout;
        if (action == TAction.acHtml) timeout = 5 * 60 * 1000;

        return this.http.post(url, dataJSon, {}, false, timeout);

    }

    methodo(action: TAction, methodoTipo: TMethodoTipo = TMethodoTipo.mtNone): Observable<any> {

        let url = 'SYNC-Methodo?Action=' + TAction[action] + '&MethodoTipo=' + methodoTipo;

        return this.http.get(url);

    }

    blended(action: TAction, brandedID: number = 0, blendTipo: TBlendedTipo = TBlendedTipo.btNone, json: any = null): Observable<any> {

        let url = 'SYNC-Blended?Action=' + TAction[action] + '&BrandedID=' + brandedID + '&BlendedTipo=' + blendTipo;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    escolha(action: TAction, escolhaID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Escolha?Action=' + TAction[action] + '&EscolhaID=' + escolhaID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    esconde(action: TAction, hotspotID: number, escolhaID: number = 0): Observable<any> {

        let url = 'SYNC-Esconde?Action=' + TAction[action] + '&EscolhaID=' + escolhaID + '&HotspotID=' + hotspotID;

        return this.http.get(url);

    }

    package(action: TAction, packageID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Package?Action=' + TAction[action] + '&PackageID=' + packageID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    produto(action: TAction, produtoID: number = 0, hotspotID: number = 0): Observable<any> {

        let url = 'SYNC-Produto?Action=' + TAction[action] + '&ProdutoID=' + produtoID + '&HotspotID=' + hotspotID;

        return this.http.get(url);

    }

    gatewey(action: TAction, hotspotID: number = 0, json: any = null): Observable<any> {

        let url = 'SYNC-Gatewey?Action=' + TAction[action] + '&HotspotID=' + hotspotID;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    meritum(action: TAction, meritumID: number = 0, brandedID: number = 0, hotspotID: number = 0, profileID: number = 0, findText: string = '', json: any = null): Observable<any> {

        let url = 'SYNC-Meritum?Action=' + TAction[action] + '&MeritumID=' + meritumID + '&BrandedID=' + brandedID + '&HotspotID=' + hotspotID + '&ProfileID=' + profileID + '&Pesquisa=' + findText;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        return this.http.post(url, dataJSon);

    }

    certify(action: TAction, meritumID: number, blendedID: number = 0, produtoID: number = 0, certifyID: number = 0, hotspotID: number = 0, usuarioID: number = 0, profileID: number = 0, produtoTipo: TProdutoTipo = TProdutoTipo.ptNone, membersexo: TProfileSexo = TProfileSexo.psNenhum, certifyFlag: TCertifyFlag = TCertifyFlag.cfStatus, memberExpira: string = '', limitPage: number = 0, findText: string = ''): Observable<any> {

        let url = 'SYNC-Certify?Action=' + TAction[action] + '&MeritumID=' + meritumID + '&BlendedID=' + blendedID + '&ProdutoID=' + produtoID + '&CertifyID=' + certifyID + '&HotspotID=' + hotspotID + '&UsuarioID=' + usuarioID + '&ProfileID=' + profileID + '&ProdutoTipo=' + produtoTipo + '&Membersexo=' + membersexo + '&CertifyFlag=' + certifyFlag + '&Expira=' + memberExpira + '&LimitPage=' + limitPage + '&LimitQtde=200' + '&Pesquisa=' + findText;

        let timeout = (action == TAction.acFile ? ((1000 * 60) * 3) : CONFIG.request.totalTimeout);
        return this.http.get(url, {}, false, timeout);

    }

    zipload(action: TAction, ziptipo: TZiptipo, zipfind: string = ''): Observable<any> {

        let url = 'SYNC-Zipload?Action=' + TAction[action] + '&Ziptipo=' + ziptipo + '&Zipfind=' + zipfind;

        return this.http.get(url);

    }


}



// WEBPACK FOOTER //
// ./src/providers/webstor-service.ts